import React from 'react';
import $ from 'jquery';
import { Draggable } from 'react-beautiful-dnd';
import { languageDirection } from '../../i18n';
import { IProviderItemLinkView } from '../../store/providers/providerTypes';

interface IProps {
  index: number;
  expectedOrder: number;
  isASearchList: boolean;
  isLink: false | IProviderItemLinkView | undefined;
  item: any;
  lastIndex?: number;
  listIndex: number;
  selected: boolean | null;
  disableDrag: boolean;
  lastList?: boolean;
  mandatoryTagIds?: number[];
}

const ListItem: React.FC<IProps> = ({
  expectedOrder,
  index,
  isASearchList,
  isLink,
  item,
  lastList,
  listIndex,
  selected,
  disableDrag,
  mandatoryTagIds,
}) => {
  const isDragDisabled = (!item.order ||
    selected ||
    !item.isEditable ||
    isASearchList ||
    disableDrag ||
    !!isLink) as boolean;

  return (
    <Draggable
      index={index}
      draggableId={item.id}
      isDragDisabled={isDragDisabled}
    >
      {(provided) => (
        <div style={{ position: 'relative' }}>
          <div
            className="hover-area"
            ref={provided.innerRef}
            {...provided.draggableProps}
          >
            {!isDragDisabled && (
              <span
                className={
                  'visible-on-hover ' +
                  `${languageDirection() === 'rtl' ? 'drag-handle-right' : 'drag-handle-left'}`
                }
                {...provided.dragHandleProps}
                onClick={(e) => {
                  $(e.target)
                    .closest('.hover-area')
                    .find('.clickable')
                    .trigger('click');
                }}
              >
                <i className="drag-noicon" />
              </span>
            )}
            {item.getComponent(
              listIndex,
              lastList || selected,
              expectedOrder,
              isLink,
              isASearchList,
              mandatoryTagIds
            )}
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default React.memo(ListItem);
